var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitesFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83.3333,
    height: 83.3333,
    rx: 41.6667,
    fill: "#EBEBFB",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2345 45.6533C45.648 47.2597 41.666 51.2915 41.666 51.2915C41.666 51.2915 37.5864 47.1608 36.0975 45.6533C33.0222 42.5394 33.0222 37.4908 36.0975 34.3769C39.1729 31.263 44.1591 31.263 47.2345 34.3769C50.3099 37.4908 50.3099 42.5394 47.2345 45.6533Z",
    stroke: "#20ACD9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.291 39.3332C44.291 40.7829 43.1158 41.9582 41.666 41.9582C40.2163 41.9582 39.041 40.7829 39.041 39.3332C39.041 37.8834 40.2163 36.7082 41.666 36.7082C43.1158 36.7082 44.291 37.8834 44.291 39.3332Z",
    stroke: "#20ACD9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitesFilter);
export default __webpack_public_path__ + "static/media/sites_filter.95a2f2c148fe3f23f825f18d3cb107bb.svg";
export { ForwardRef as ReactComponent };